import gql from 'graphql-tag';

import recentlyViewedMainDisplayObjectFragment from './recentlyViewedMainDisplayObjectFragment';

export const recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment = gql`
  fragment recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment on RecentlyViewedMainDisplayObjectsGroupedByDokkioLabel {
    dokkioClass
    dokkioLabelID
    recentlyViewedMainDisplayObjects {
      ...recentlyViewedMainDisplayObjectFragment
    }
  }
  ${recentlyViewedMainDisplayObjectFragment}
`;
export default recentlyViewedMainDisplayObjectsGroupedByDokkioLabelFragment;
